import * as platformTenants from "../mockData/platform/tenants";
import * as platformDashboard from "../mockData/platform/dashboard";
import * as platformSubscriptions from "../mockData/platform/subscriptions";
import * as platformUsage from "../mockData/platform/usageQuotas";
import * as platformIntegrations from "../mockData/platform/integrations";
import * as platformJobs from "../mockData/platform/jobs";
import * as platformTemplates from "../mockData/platform/templates";
import * as platformAi from "../mockData/platform/aiPolicies";
import * as platformAudit from "../mockData/platform/auditSecurity";
import * as platformBilling from "../mockData/platform/billing";
import * as platformSupport from "../mockData/platform/support";
import * as platformSettings from "../mockData/platform/settings";
import * as companyDashboard from "../mockData/company/dashboard";
import * as companyUsers from "../mockData/company/users";
import * as companyDepartments from "../mockData/company/departments";
import * as companyIntegrations from "../mockData/company/integrations";
import * as companyChannels from "../mockData/company/channels";
import * as companyScheduling from "../mockData/company/scheduling";
import * as companyDirectory from "../mockData/company/attendeeDirectory";
import * as companyMeetings from "../mockData/company/meetings";
import * as companyTranscripts from "../mockData/company/transcripts";
import * as companyTemplates from "../mockData/company/templates";
import * as companyNotifications from "../mockData/company/notifications";
import * as companyReports from "../mockData/company/reports";
import * as companyAudit from "../mockData/company/audit";
import * as companySettings from "../mockData/company/settings";

const delayMs = () => 400 + Math.random() * 400;

async function sleep() {
  await new Promise((r) => setTimeout(r, delayMs()));
}

async function wrap(payload) {
  try {
    await sleep();

    return { data: payload, status: 200 };
  } catch (e) {
    throw e;
  }
}

/** Mutations / ack — no random failure */
async function wrapMutate(payload) {
  await sleep();
  return { data: payload, status: 200 };
}

let alertsMutable = platformDashboard.alertsList.map((a) => ({ ...a }));

let plansMutable = null;
function getPlansMutable() {
  if (!plansMutable) {
    plansMutable = JSON.parse(
      JSON.stringify(platformSubscriptions.planCatalog),
    );
  }
  return plansMutable;
}

let subsMutable = null;
function getSubsMutable() {
  if (!subsMutable) {
    subsMutable = JSON.parse(
      JSON.stringify(platformSubscriptions.tenantSubscriptions),
    );
  }
  return subsMutable;
}

let overageBuckets = null;
function getOverageBuckets() {
  if (!overageBuckets) {
    overageBuckets = {
      open: JSON.parse(JSON.stringify(platformUsage.overageReviewItems)),
      history: JSON.parse(JSON.stringify(platformUsage.overageHistoryItems)),
    };
  }
  return overageBuckets;
}

const quotaPolicyStore = {};

/* —— Mutable: platform jobs —— */
let jobQueueCardsMutable = null;
function getJobQueueCardsMut() {
  if (!jobQueueCardsMutable) {
    jobQueueCardsMutable = JSON.parse(
      JSON.stringify(platformJobs.jobQueueCards),
    );
  }
  return jobQueueCardsMutable;
}
let platformJobsListMutable = null;
function getPlatformJobsListMut() {
  if (!platformJobsListMutable) {
    platformJobsListMutable = JSON.parse(
      JSON.stringify(platformJobs.platformJobsList),
    );
  }
  return platformJobsListMutable;
}
let retryCenterJobsMutable = null;
function getRetryCenterJobsMut() {
  if (!retryCenterJobsMutable) {
    retryCenterJobsMutable = JSON.parse(
      JSON.stringify(platformJobs.retryCenterJobs),
    );
  }
  return retryCenterJobsMutable;
}

/* —— Mutable: templates —— */
let globalTemplatesMutable = null;
function getGlobalTemplatesMut() {
  if (!globalTemplatesMutable) {
    globalTemplatesMutable = JSON.parse(
      JSON.stringify(platformTemplates.globalTemplatesList),
    );
  }
  return globalTemplatesMutable;
}
const templateDetailOverrides = {};

/* —— Mutable: AI policies —— */
let aiPoliciesMutable = null;
function getAiPoliciesMut() {
  if (!aiPoliciesMutable) {
    aiPoliciesMutable = JSON.parse(JSON.stringify(platformAi.aiPolicyList));
  }
  return aiPoliciesMutable;
}
let modelRoutingMutable = null;
function getModelRoutingMut() {
  if (!modelRoutingMutable) {
    modelRoutingMutable = JSON.parse(
      JSON.stringify(platformAi.modelRoutingGrid),
    );
  }
  return modelRoutingMutable;
}

let securityCenterMutable = null;
function getSecurityCenterMut() {
  if (!securityCenterMutable) {
    securityCenterMutable = JSON.parse(
      JSON.stringify(platformAudit.securityCenterData),
    );
  }
  return securityCenterMutable;
}
let accessReviewRowsMutable = null;
function getAccessReviewRowsMut() {
  if (!accessReviewRowsMutable) {
    accessReviewRowsMutable = JSON.parse(
      JSON.stringify(platformAudit.accessReviewRowsSeed),
    );
  }
  return accessReviewRowsMutable;
}
let invoicesMutable = null;
function getInvoicesMut() {
  if (!invoicesMutable) {
    invoicesMutable = JSON.parse(JSON.stringify(platformBilling.invoicesList));
  }
  return invoicesMutable;
}
let paymentIssuesMutable = null;
function getPaymentIssuesMut() {
  if (!paymentIssuesMutable) {
    paymentIssuesMutable = JSON.parse(
      JSON.stringify(platformBilling.paymentIssues),
    );
  }
  return paymentIssuesMutable;
}
let ticketsMutable = null;
function getTicketsMut() {
  if (!ticketsMutable) {
    ticketsMutable = JSON.parse(JSON.stringify(platformSupport.ticketsList));
  }
  return ticketsMutable;
}
let runbooksMutable = null;
function getRunbooksMut() {
  if (!runbooksMutable) {
    runbooksMutable = JSON.parse(JSON.stringify(platformSupport.runbooksList));
  }
  return runbooksMutable;
}
let generalSettingsMutable = null;
function getGeneralSettingsMut() {
  if (!generalSettingsMutable) {
    generalSettingsMutable = JSON.parse(
      JSON.stringify(platformSettings.generalSettings),
    );
  }
  return generalSettingsMutable;
}
let featureFlagsMutable = null;
function getFeatureFlagsMut() {
  if (!featureFlagsMutable) {
    featureFlagsMutable = JSON.parse(
      JSON.stringify(platformSettings.featureFlags),
    );
  }
  return featureFlagsMutable;
}
let retentionMatrixMutable = null;
function getRetentionMatrixMut() {
  if (!retentionMatrixMutable) {
    retentionMatrixMutable = JSON.parse(
      JSON.stringify(platformSettings.storageRetentionMatrix),
    );
  }
  return retentionMatrixMutable;
}

/* —— Platform: tenants —— */
export async function getTenantDetailAPI(tenantId) {
  await sleep();

  const row = platformTenants.tenantsList.find((t) => t.id === tenantId);
  const base = row
    ? { ...platformTenants.tenantDetail, ...row, id: tenantId }
    : {
        ...platformTenants.tenantDetail,
        id: tenantId,
        tenantCode: "MH-????",
        companyName: "Unknown tenant",
      };
  const idNum = parseInt(String(tenantId).replace(/\D/g, ""), 10) || 0;
  const data = {
    ...base,
    failedJobsCount: 2 + (idNum % 8),
    subscription: platformTenants.buildTenantSubscription(base),
    integrations: platformTenants.buildTenantIntegrations(base),
    usage: platformTenants.buildTenantUsage(base),
    supportHistory: platformTenants.buildSupportHistory(tenantId),
    tenantAudit: platformTenants.buildTenantAuditMini(tenantId),
    onboardingItems: [...platformTenants.tenantOnboardingItems],
    lastSupportAction: { ...platformTenants.lastSupportActionTemplate },
  };
  return { data, status: 200 };
}

export async function getTenantOnboardingChecklistAPI() {
  return wrap(platformTenants.onboardingChecklist);
}

export async function createTenantAPI(body) {
  const code = `T-${String(Math.floor(10000 + Math.random() * 89999))}`;
  const id = `tnt-${Date.now()}`;
  return wrap({
    id,
    tenantCode: code,
    ...body,
    createdAt: new Date().toISOString(),
  });
}

export async function updateTenantAPI(tenantId, body) {
  return wrap({ id: tenantId, ...body, updatedAt: new Date().toISOString() });
}

export async function deleteTenantAPI(tenantId) {
  return wrap({ id: tenantId, deleted: true });
}

export async function suspendTenantAPI(tenantId, reason) {
  return wrapMutate({
    id: tenantId,
    status: "suspended",
    reason,
    updatedAt: new Date().toISOString(),
  });
}

export async function getTenantsListAPI(params = {}) {
  let list = [...platformTenants.tenantsList];
  const search = params.search != null ? String(params.search) : "";
  const page = Math.max(1, parseInt(params.page, 10) || 1);
  const limit = Math.min(100, Math.max(1, parseInt(params.limit, 10) || 20));
  if (search.trim()) {
    const q = search.toLowerCase();
    list = list.filter(
      (t) =>
        t.companyName.toLowerCase().includes(q) ||
        t.tenantCode.toLowerCase().includes(q) ||
        t.domain.toLowerCase().includes(q),
    );
  }
  if (params.plan) {
    const plans = String(params.plan)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (plans.length) list = list.filter((t) => plans.includes(t.plan));
  }
  if (params.status) {
    const sts = String(params.status)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (sts.length) list = list.filter((t) => sts.includes(t.status));
  }
  const total = list.length;
  const start = (page - 1) * limit;
  const items = list.slice(start, start + limit);
  return wrap({
    items,
    total,
    page,
    limit,
    summary: { active: 42, trial: 6, suspended: 3, atRisk: 2 },
  });
}

export async function checkTenantDomainAPI(domain) {
  const d = String(domain || "")
    .toLowerCase()
    .trim();
  const taken = platformTenants.tenantsList.some(
    (t) => t.domain.toLowerCase() === d,
  );
  return wrapMutate({ available: !taken, domain: d });
}

export async function startSupportSessionAPI(tenantId, payload) {
  return wrapMutate({
    tenantId,
    sessionId: `sess-${Date.now()}`,
    startedAt: new Date().toISOString(),
    ...payload,
  });
}

export async function getSupportHistoryAPI(tenantId) {
  return wrap(platformTenants.buildSupportHistory(tenantId));
}

/* —— Platform: dashboard —— */
export async function getExecutiveDashboardAPI() {
  await sleep();

  return {
    data: {
      kpis: {
        totalTenants: platformDashboard.executiveDashboardKPIs.totalTenants,
        activeTenants: platformDashboard.executiveDashboardKPIs.activeTenants,
        meetingsThisMonth:
          platformDashboard.executiveDashboardKPIs.meetingsThisMonth,
        aiSummaries: platformDashboard.executiveDashboardKPIs.aiSummaries,
        failedJobs: platformDashboard.executiveDashboardKPIs.failedJobs,
        mrrUsd: platformDashboard.executiveDashboardKPIs.mrrUsd,
      },
      meetingsByDay: platformDashboard.meetingsByDay,
      planMixData: platformDashboard.planMixData,
      connectorStrip: platformDashboard.connectorHealthStrip,
      topTenantsByUsage: platformDashboard.topTenantsByUsage,
      expiringSubscriptions: platformDashboard.expiringSubscriptions,
      criticalAlerts: platformDashboard.criticalAlerts,
      lastSyncedAt: new Date().toISOString(),
      dataFreshnessMinutes: 4,
    },
    status: 200,
  };
}

export async function getOperationsCockpitAPI() {
  return wrap({
    providers: platformDashboard.cockpitProviderStatus,
    queues: platformDashboard.cockpitQueues,
    incidentTimeline: platformDashboard.cockpitIncidentTimeline,
    webhookHourly: platformDashboard.cockpitWebhookHourly,
    supportEscalations: platformDashboard.cockpitSupportEscalations,
    regions: platformDashboard.operationsCockpitData.regions,
    deployVersion: platformDashboard.operationsCockpitData.deployVersion,
    lastIncident: platformDashboard.operationsCockpitData.lastIncident,
  });
}

export async function getAlertsListAPI() {
  return wrap(alertsMutable);
}

export async function acknowledgeAlertAPI(alertId) {
  alertsMutable = alertsMutable.map((a) =>
    a.id === alertId ? { ...a, acknowledged: true, status: "acknowledged" } : a,
  );
  return wrapMutate({ id: alertId, ok: true });
}

export async function getPlatformDashboardAPI() {
  return wrap({
    executiveDashboardKPIs: platformDashboard.executiveDashboardKPIs,
    meetingsByDay: platformDashboard.meetingsByDay,
    planMixData: platformDashboard.planMixData,
    connectorHealthStrip: platformDashboard.connectorHealthStrip,
    topTenantsByUsage: platformDashboard.topTenantsByUsage,
    expiringSubscriptions: platformDashboard.expiringSubscriptions,
    criticalAlerts: platformDashboard.criticalAlerts,
    operationsCockpitData: platformDashboard.operationsCockpitData,
    queueStats: platformDashboard.queueStats,
    alertsList: platformDashboard.alertsList,
  });
}

export async function getExecutiveDashboardKPIsAPI() {
  return wrap(platformDashboard.executiveDashboardKPIs);
}

export async function getMeetingsByDayAPI() {
  return wrap(platformDashboard.meetingsByDay);
}

/* —— Platform: subscriptions —— */
export async function getPlanCatalogAPI() {
  return wrap({
    plans: getPlansMutable(),
    featureMatrix: platformSubscriptions.planFeatureMatrix,
    versionHistory: platformSubscriptions.planVersionHistory,
  });
}

export async function createPlanAPI(body) {
  const plan = {
    id: `plan-${Date.now()}`,
    name: body.name || "New Plan",
    price: body.price ?? 0,
    billingCycle: body.billingCycle || "monthly",
    userLimit: body.userLimit ?? 50,
    meetingQuota: body.meetingQuota ?? 500,
    aiTokenQuota: body.aiTokenQuota ?? 500000,
    storageGB: body.storageGB ?? 25,
    features: body.features || ["Feature 1"],
    isActive: true,
    archived: false,
    version: body.version || "2025.2",
    activeTenantsCount: 0,
  };
  getPlansMutable().push(plan);
  return wrapMutate(plan);
}

export async function archivePlanAPI(planId) {
  getPlansMutable().forEach((p) => {
    if (p.id === planId) {
      p.archived = true;
      p.isActive = false;
    }
  });
  return wrapMutate({ id: planId, archived: true });
}

export async function getTenantSubscriptionsAPI() {
  return wrap(getSubsMutable());
}

export async function updateSubscriptionAPI(subId, patch) {
  const row = getSubsMutable().find((s) => s.id === subId);
  if (row) {
    if (patch.commercialTerms) {
      row.commercialTerms = {
        ...row.commercialTerms,
        ...patch.commercialTerms,
      };
    } else {
      Object.assign(row, patch);
    }
  }
  return wrapMutate({ id: subId, ok: true });
}

export async function terminateSubscriptionAPI(subId, reason) {
  const row = getSubsMutable().find((s) => s.id === subId);
  if (row) {
    row.status = "cancelled";
    row.terminationReason = reason;
  }
  return wrapMutate({ id: subId, status: "cancelled", reason });
}

export async function getRenewalCalendarEventsAPI() {
  return wrap(platformSubscriptions.renewalCalendarEvents);
}

export async function getRenewalCalendarAPI() {
  return wrap({
    events: platformSubscriptions.renewalCalendarEvents,
    atRiskSidebar: platformSubscriptions.atRiskRenewalsSidebar,
  });
}

/* —— Platform: usage & quotas —— */
function mapUsageTableRows(metric) {
  const rows = platformUsage.tenantUsageRows;
  return rows.map((r) => {
    let used;
    let limit;
    let forecast;
    if (metric === "ai_tokens") {
      used = r.aiTokensUsedM;
      limit = r.aiTokensQuotaM;
      forecast = used * 1.12;
    } else if (metric === "storage") {
      used = r.storageUsedGb;
      limit = r.storageQuotaGb;
      forecast = used + 12;
    } else if (metric === "channels") {
      used = r.channelsUsed;
      limit = r.channelsQuota;
      forecast = used * 1.08;
    } else if (metric === "users") {
      used = r.usersUsed;
      limit = r.usersQuota;
      forecast = used + 4;
    } else {
      used = r.meetingsUsed;
      limit = r.meetingsQuota;
      forecast = used + 180;
    }
    const pct = Math.min(100, Math.round((used / limit) * 100));
    return {
      id: r.tenantId,
      tenant: `${r.tenantCode} — ${r.companyName}`,
      tenantCode: r.tenantCode,
      metricUsed: used,
      limit,
      pctUsed: pct,
      forecast,
      forecastExceeds: forecast > limit,
      status: pct > 90 ? "critical" : pct >= 70 ? "warning" : "ok",
    };
  });
}

export async function getUsageOverviewAPI(metric = "meetings", dateRange) {
  const keyMap = {
    meetings: "meetings",
    ai_tokens: "ai_tokens",
    storage: "storage",
    channels: "channels",
    users: "users",
  };
  const k = keyMap[metric] || "meetings";
  return wrap({
    metric: k,
    dateRange: dateRange || "last_90d",
    overview: platformUsage.usageOverview,
    stack:
      platformUsage.usageByPlanStack[k] ||
      platformUsage.usageByPlanStack.meetings,
    topTenants:
      platformUsage.usageTopTenantsByMetric[k] ||
      platformUsage.usageTopTenantsByMetric.meetings,
    trend: platformUsage.usageTrend6m[k] || platformUsage.usageTrend6m.meetings,
    tableRows: mapUsageTableRows(k),
  });
}

export async function getTenantUsageRowsAPI() {
  return wrap(platformUsage.tenantUsageRows);
}

export async function getQuotaPoliciesAPI(planKey = "Starter") {
  const base =
    platformUsage.quotaPolicyDetailByPlan[planKey] ||
    platformUsage.quotaPolicyDetailByPlan.Starter;
  const override = quotaPolicyStore[planKey];
  return wrap({
    planKey,
    policies: override || base,
    list: platformUsage.quotaPolicies,
  });
}

export async function updateQuotaPoliciesAPI(planKey, policies) {
  quotaPolicyStore[planKey] = policies;
  return wrapMutate({ planKey, ok: true });
}

export async function getOverageReviewItemsAPI() {
  return wrap(getOverageBuckets().open);
}

export async function getOverageItemsAPI() {
  const b = getOverageBuckets();
  return wrap({ open: b.open, history: b.history });
}

export async function resolveOverageAPI(id, action) {
  const b = getOverageBuckets();
  const idx = b.open.findIndex((x) => x.id === id);
  if (idx >= 0) {
    const [row] = b.open.splice(idx, 1);
    b.history.unshift({
      ...row,
      resolvedAt: new Date().toISOString(),
      action,
    });
  }
  return wrapMutate({ id, action });
}

/* —— Platform: integrations —— */
export async function getConnectorHealthBoardAPI({ refresh } = {}) {
  const jitter = () => +(97 + Math.random() * 2.9).toFixed(2);
  const cards = (
    refresh
      ? platformIntegrations.integrationProviderCards.map((c) => ({
          ...c,
          uptimePct: jitter(),
          failures24h: Math.max(
            0,
            c.failures24h + (Math.random() > 0.5 ? -1 : 1),
          ),
        }))
      : platformIntegrations.integrationProviderCards
  ).map((c) => ({ ...c }));
  return wrap({
    cards,
    affectedTenants: platformIntegrations.affectedTenantsByProvider,
    incidents: platformIntegrations.integrationRecentIncidents,
    expiringTokens: platformIntegrations.expiringTokensSoon,
    legacyBoard: platformIntegrations.connectorHealthBoard,
  });
}

export async function retryTokenTestAPI(tenantId, provider) {
  return wrapMutate({
    tenantId,
    provider,
    ok: true,
    testedAt: new Date().toISOString(),
  });
}

export async function getIntegrationDetailsAPI() {
  const d = platformIntegrations.integrationDetails;
  return wrap({
    ...d,
    microsoft_graph: d.microsoft,
    google_calendar: d.google,
    whatsapp_cloud: d.whatsapp,
  });
}

export async function getIntegrationDetailAPI(tenantId, provider) {
  return wrap(
    platformIntegrations.buildIntegrationTenantDetail(tenantId, provider),
  );
}

export async function runConnectivityTestAPI(tenantId, provider) {
  const ok = Math.random() > 0.15;
  return wrapMutate({
    tenantId,
    provider,
    ok,
    message: ok ? "Connectivity check passed" : "Upstream timeout (simulated)",
  });
}

export async function resetTokenAPI(tenantId, provider) {
  return wrapMutate({
    tenantId,
    provider,
    rotatedAt: new Date().toISOString(),
  });
}

export async function getWebhookLogsAPI(filters = {}) {
  let rows = [...platformIntegrations.webhookLogs];
  if (filters.provider) {
    rows = rows.filter((r) => r.provider === filters.provider);
  }
  if (filters.statusGroup === "4xx") {
    rows = rows.filter((r) => r.httpStatus >= 400 && r.httpStatus < 500);
  } else if (filters.statusGroup === "5xx") {
    rows = rows.filter((r) => r.httpStatus >= 500);
  } else if (filters.statusGroup === "200") {
    rows = rows.filter((r) => r.httpStatus === 200);
  }
  if (filters.tenantId) {
    rows = rows.filter((r) => r.tenantId === filters.tenantId);
  }
  if (filters.timeRange === "1h") {
    rows = rows.filter(
      (r) => Date.now() - new Date(r.receivedAt).getTime() < 3600000,
    );
  } else if (filters.timeRange === "6h") {
    rows = rows.filter(
      (r) => Date.now() - new Date(r.receivedAt).getTime() < 21600000,
    );
  } else if (filters.timeRange === "24h" || !filters.timeRange) {
    rows = rows.filter(
      (r) => Date.now() - new Date(r.receivedAt).getTime() < 86400000,
    );
  }
  return wrap(rows);
}

export async function replayWebhookAPI(id) {
  return wrapMutate({ id, replayed: true, at: new Date().toISOString() });
}

/* —— Platform: jobs —— */
export async function getJobQueuesAPI() {
  return wrap(platformJobs.jobQueues);
}

export async function getJobsListAPI() {
  return wrap(getPlatformJobsListMut());
}

export async function getFailureDetailsAPI() {
  return wrap(platformJobs.failureDetails);
}

export async function getRetryCenterItemsAPI() {
  return wrap(getRetryCenterJobsMut());
}

function filterJobQueueJobs(jobs, filters = {}) {
  let out = [...jobs];
  if (filters.queue) {
    out = out.filter((j) => j.queue === filters.queue);
  }
  if (filters.status) {
    const sts = String(filters.status)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (sts.length) out = out.filter((j) => sts.includes(j.status));
  }
  if (filters.tenantSearch && String(filters.tenantSearch).trim()) {
    const q = String(filters.tenantSearch).toLowerCase();
    out = out.filter(
      (j) =>
        (j.tenantCode && j.tenantCode.toLowerCase().includes(q)) ||
        (j.companyName && j.companyName.toLowerCase().includes(q)) ||
        (j.tenantId && j.tenantId.toLowerCase().includes(q)),
    );
  }
  if (filters.dateFrom) {
    const t = new Date(filters.dateFrom).getTime();
    out = out.filter((j) => new Date(j.createdAt).getTime() >= t);
  }
  if (filters.dateTo) {
    const t = new Date(filters.dateTo).getTime();
    out = out.filter((j) => new Date(j.createdAt).getTime() <= t);
  }
  return out;
}

export async function getJobQueueAPI(filters = {}) {
  return wrap({
    queues: getJobQueueCardsMut(),
    jobs: filterJobQueueJobs(getPlatformJobsListMut(), filters),
  });
}

export async function pauseQueueAPI(queueKey) {
  const q = getJobQueueCardsMut().find((x) => x.key === queueKey);
  if (q) {
    q.status = "paused";
  }
  return wrapMutate({ queueKey, status: "paused" });
}

export async function resumeQueueAPI(queueKey) {
  const q = getJobQueueCardsMut().find((x) => x.key === queueKey);
  if (q) q.status = "running";
  return wrapMutate({ queueKey, status: "running" });
}

export async function retryAllRetryableAPI() {
  const jobs = getPlatformJobsListMut();
  let n = 0;
  jobs.forEach((j) => {
    if (j.status === "failed") {
      j.status = "queued";
      j.errorCode = null;
      j.errorMessage = null;
      n += 1;
    }
  });
  return wrapMutate({ requeued: n });
}

export async function getJobDetailAPI(id) {
  return wrap(platformJobs.buildJobDetail(id));
}

export async function retryJobAPI(id) {
  const j = getPlatformJobsListMut().find((x) => x.id === id);
  if (j) {
    j.status = "queued";
    j.errorCode = null;
    j.errorMessage = null;
  }
  return wrapMutate({ id, status: "queued" });
}

export async function ignoreJobAPI(id, note) {
  const j = getPlatformJobsListMut().find((x) => x.id === id);
  if (j) {
    j.status = "ignored";
    j.ignoreNote = note;
  }
  return wrapMutate({ id, ignored: true, note });
}

function filterRetryJobs(rows, filters = {}) {
  let out = [...rows];
  if (filters.queue) out = out.filter((r) => r.queue === filters.queue);
  if (filters.provider)
    out = out.filter((r) => r.provider === filters.provider);
  if (filters.status) out = out.filter((r) => r.status === filters.status);
  if (filters.timeRange === "24h") {
    const t = Date.now() - 86400000;
    out = out.filter((r) => new Date(r.failedAt).getTime() >= t);
  } else if (filters.timeRange === "7d") {
    const t = Date.now() - 7 * 86400000;
    out = out.filter((r) => new Date(r.failedAt).getTime() >= t);
  }
  return out;
}

export async function getRetryableJobsAPI(filters = {}) {
  return wrap(filterRetryJobs(getRetryCenterJobsMut(), filters));
}

export async function bulkRetryJobsAPI(ids, options = {}) {
  const set = new Set(ids);
  getRetryCenterJobsMut().forEach((r) => {
    if (set.has(r.id) || set.has(r.jobId)) {
      r.status = "retry_queued";
    }
  });
  return wrapMutate({ count: ids.length, options });
}

export async function scheduleRetryAPI(payload) {
  return wrapMutate({ scheduled: true, ...payload });
}

/* —— Platform: templates —— */
export async function getGlobalTemplatesListAPI() {
  return wrap(getGlobalTemplatesMut());
}

export async function getTemplateLibraryAPI(filters = {}) {
  let list = [...getGlobalTemplatesMut()];
  if (filters.channel && filters.channel !== "all") {
    list = list.filter((t) => t.channel === filters.channel);
  }
  if (filters.useCase && filters.useCase !== "all") {
    list = list.filter((t) => t.useCase === filters.useCase);
  }
  if (filters.status && filters.status !== "all") {
    list = list.filter((t) => t.status === filters.status);
  }
  if (filters.search && String(filters.search).trim()) {
    const q = String(filters.search).toLowerCase();
    list = list.filter((t) => t.name.toLowerCase().includes(q));
  }
  return wrap(list);
}

export async function cloneTemplateAPI(id) {
  const list = getGlobalTemplatesMut();
  const src = list.find((t) => t.id === id);
  if (!src) return wrapMutate({ ok: false });
  const nid = `gtpl-${Date.now()}`;
  list.unshift({
    ...JSON.parse(JSON.stringify(src)),
    id: nid,
    name: `${src.name} (copy)`,
    status: "draft",
    version: "v1.0",
    updatedAt: new Date().toISOString(),
  });
  return wrapMutate({ id: nid });
}

export async function archiveTemplateAPI(id) {
  const t = getGlobalTemplatesMut().find((x) => x.id === id);
  if (t) t.status = "archived";
  return wrapMutate({ id, archived: true });
}

export async function getTemplateDetailAPI(id) {
  const base = platformTemplates.buildTemplateDetail(id);
  const ov = templateDetailOverrides[id];
  return wrap(ov ? { ...base, ...ov } : base);
}

export async function saveTemplateDraftAPI(id, body) {
  const list = getGlobalTemplatesMut();
  let tid = id;
  let row = id && id !== "new" ? list.find((t) => t.id === id) : null;

  if (!id || id === "new") {
    tid = `gtpl-${Date.now()}`;
    row = {
      id: tid,
      name: body.name || "Untitled template",
      channel: body.channel || "teams",
      useCase: body.useCase || "Reminder",
      status: "draft",
      version: "v0.1",
      updatedAt: new Date().toISOString(),
      bodyMarkdown: body.bodyMarkdown || "",
      subject: body.subject || "",
      category: "General",
      locale: "en",
      isDefault: false,
      usageCount7d: 0,
    };
    list.unshift(row);
  } else if (!row) {
    tid = id;
    row = {
      id: tid,
      name: body.name || "Untitled template",
      channel: body.channel || "teams",
      useCase: body.useCase || "Reminder",
      status: "draft",
      version: "v0.1",
      updatedAt: new Date().toISOString(),
      bodyMarkdown: body.bodyMarkdown || "",
      subject: body.subject || "",
      category: "General",
      locale: "en",
      isDefault: false,
      usageCount7d: 0,
    };
    list.unshift(row);
  }

  templateDetailOverrides[tid] = {
    ...(templateDetailOverrides[tid] || {}),
    ...body,
    updatedAt: new Date().toISOString(),
  };
  if (body.name) row.name = body.name;
  if (body.bodyMarkdown != null) row.bodyMarkdown = body.bodyMarkdown;
  if (body.subject != null) row.subject = body.subject;
  if (body.channel) row.channel = body.channel;
  if (body.useCase) row.useCase = body.useCase;
  row.status = "draft";
  row.updatedAt = new Date().toISOString();
  return wrapMutate({ id: tid, saved: true });
}

export async function publishTemplateAPI(id) {
  const row = getGlobalTemplatesMut().find((t) => t.id === id);
  if (row) {
    row.status = "active";
    row.updatedAt = new Date().toISOString();
  }
  return wrapMutate({ id, published: true });
}

export async function rollbackTemplateAPI(templateId, versionNum) {
  return wrapMutate({ templateId, versionNum, rolledBack: true });
}

export async function getTemplateVersionsAPI(templateId) {
  return wrap(platformTemplates.buildTemplateVersions(templateId || "gtpl-0"));
}

/* —— Platform: AI policies —— */
export async function getAIPoliciesAPI() {
  return wrap(getAiPoliciesMut());
}

export async function getAiPolicyListAPI() {
  return wrap(getAiPoliciesMut());
}

export async function updateAIPolicyScopeAPI(id, scope) {
  const p = getAiPoliciesMut().find((x) => x.id === id);
  if (p) {
    p.scopeLabel = scope.label;
    p.scopeType = scope.type;
  }
  return wrapMutate({ id, scope });
}

export async function disableAIPolicyAPI(id) {
  const p = getAiPoliciesMut().find((x) => x.id === id);
  if (p) p.status = "disabled";
  return wrapMutate({ id, disabled: true });
}

export async function getPromptDetailAPI(id) {
  const d =
    platformAi.promptDetailById[id] || platformAi.promptDetailById["aip-0"];
  return wrap({ ...d, id: id || d.id });
}

export async function runPromptTestAPI(id, input) {
  return wrapMutate({
    id,
    outputJson: JSON.stringify(
      {
        intent: "book_meeting",
        attendees: ["user@acme.com"],
        confidence: 0.91,
        raw: String(input || "").slice(0, 120),
      },
      null,
      2,
    ),
    confidence: 0.91,
    validation: {
      schemaOk: true,
      fieldsOk: true,
      confidenceOk: true,
    },
  });
}

export async function publishPromptAPI(id) {
  return wrapMutate({ id, published: true });
}

export async function getModelRoutingAPI() {
  return wrap(getModelRoutingMut());
}

export async function getModelRoutingGridAPI() {
  return wrap(getModelRoutingMut());
}

export async function updateModelRoutingAPI(rows) {
  modelRoutingMutable = JSON.parse(JSON.stringify(rows));
  return wrapMutate({ ok: true });
}

export async function testRouteLatencyAPI(routeId) {
  const ms = 200 + Math.floor(Math.random() * 600);
  return wrapMutate({ routeId, latencyMs: ms });
}

/* —— Platform: audit & security —— */
export async function getAuditLogsAPI(filters = {}, page = 1) {
  const pageSize = 50;
  let rows = JSON.parse(JSON.stringify(platformAudit.auditLogs));
  rows.sort((a, b) => new Date(b.ts) - new Date(a.ts));
  if (filters.actorSearch && String(filters.actorSearch).trim()) {
    const q = String(filters.actorSearch).toLowerCase();
    rows = rows.filter((r) => r.actor.toLowerCase().includes(q));
  }
  if (filters.tenantId) {
    rows = rows.filter((r) => r.tenantId === filters.tenantId);
  }
  if (filters.actionType && filters.actionType !== "All") {
    rows = rows.filter((r) => r.actionType === filters.actionType);
  }
  if (filters.dateFrom) {
    const t = new Date(filters.dateFrom).getTime();
    rows = rows.filter((r) => new Date(r.ts).getTime() >= t);
  }
  if (filters.dateTo) {
    const t = new Date(filters.dateTo).getTime();
    rows = rows.filter((r) => new Date(r.ts).getTime() <= t);
  }
  const total = rows.length;
  const p = Math.max(1, parseInt(page, 10) || 1);
  const start = (p - 1) * pageSize;
  return wrap({
    items: rows.slice(start, start + pageSize),
    total,
    page: p,
    pageSize,
  });
}

export async function exportAuditLogsAPI() {
  return wrapMutate({ ok: true });
}

export async function getSecurityCenterDataAPI() {
  return wrap(getSecurityCenterMut());
}

export async function getSecurityCenterAPI() {
  return wrap(getSecurityCenterMut());
}

export async function rotateSecretAPI(secretId) {
  const s = getSecurityCenterMut().secrets.find((x) => x.id === secretId);
  if (s) {
    s.ageDays = 0;
    s.status = "ok";
    s.lastRotatedAt = new Date().toISOString();
  }
  return wrapMutate({ secretId, rotated: true });
}

export async function rotateAllDueSecretsAPI() {
  getSecurityCenterMut().secrets.forEach((s) => {
    if (s.status === "overdue" || s.ageDays > 180) {
      s.ageDays = 0;
      s.status = "ok";
      s.lastRotatedAt = new Date().toISOString();
    }
  });
  getSecurityCenterMut().criticalStaleSecrets = 0;
  return wrapMutate({ rotated: "all_due" });
}

export async function endSupportSessionAPI() {
  const d = getSecurityCenterMut();
  d.activeSupportSessions = 0;
  return wrapMutate({ ended: true });
}

export async function getAccessReviewCampaignsAPI() {
  return wrap(platformAudit.accessReviewCampaigns);
}

export async function getAccessReviewsAPI(campaignId = "camp-q1") {
  const rows = getAccessReviewRowsMut().filter(
    (r) => r.campaignId === campaignId,
  );
  return wrap(rows);
}

export async function makeReviewDecisionAPI(userId, decision, note) {
  const r = getAccessReviewRowsMut().find((x) => x.userId === userId);
  if (r) {
    r.decision = decision;
    r.note = note || "";
  }
  return wrapMutate({ userId, decision });
}

export async function startAccessReviewCampaignAPI(body) {
  return wrapMutate({ id: `camp-${Date.now()}`, ...body });
}

/* —— Platform: billing —— */
export async function getBillingDashboardDataAPI() {
  return wrap(platformBilling.billingDashboardData);
}

export async function getBillingDashboardAPI() {
  return wrap(platformBilling.billingDashboardData);
}

export async function getInvoicesListAPI() {
  return wrap(getInvoicesMut());
}

export async function getInvoicesAPI(filters = {}) {
  let rows = [...getInvoicesMut()];
  if (filters.status && filters.status !== "All") {
    const st = String(filters.status).toLowerCase();
    rows = rows.filter((r) => String(r.status).toLowerCase() === st);
  }
  if (filters.tenantSearch && String(filters.tenantSearch).trim()) {
    const q = String(filters.tenantSearch).toLowerCase();
    rows = rows.filter(
      (r) =>
        r.tenantCode.toLowerCase().includes(q) ||
        r.companyName.toLowerCase().includes(q),
    );
  }
  if (filters.dateFrom) {
    const t = new Date(filters.dateFrom).getTime();
    rows = rows.filter((r) => new Date(r.issuedAt).getTime() >= t);
  }
  if (filters.dateTo) {
    const t = new Date(filters.dateTo).getTime();
    rows = rows.filter((r) => new Date(r.issuedAt).getTime() <= t);
  }
  return wrap(rows);
}

export async function markInvoicePaidAPI(id, paidAt) {
  const inv = getInvoicesMut().find((x) => x.id === id);
  if (inv) {
    inv.status = "paid";
    inv.paidAt = paidAt || new Date().toISOString();
  }
  return wrapMutate({ id, paid: true });
}

export async function sendPaymentReminderAPI(id) {
  return wrapMutate({ id, reminded: true });
}

export async function getPaymentIssuesAPI() {
  return wrap(getPaymentIssuesMut());
}

export async function retryChargeAPI(id) {
  return wrapMutate({ id, retried: true });
}

export async function waivePaymentAPI(id, note) {
  if (localStorage.getItem("mh_payment_waive_role") !== "1") {
    throw new Error(
      "Waive requires role: set localStorage mh_payment_waive_role = 1",
    );
  }
  const p = getPaymentIssuesMut().find((x) => x.id === id);
  if (p) p.status = "waived";
  return wrapMutate({ id, waived: true, note });
}

export async function bulkApproveUndecidedAPI(campaignId) {
  getAccessReviewRowsMut()
    .filter(
      (r) =>
        r.campaignId === campaignId &&
        (r.decision == null || r.decision === ""),
    )
    .forEach((r) => {
      r.decision = "approve";
    });
  return wrapMutate({ campaignId, ok: true });
}

export async function retryFailedJobsForTenantAPI(tenantId) {
  return wrapMutate({ tenantId, queued: true });
}

/* —— Platform: support —— */
export async function getTicketsListAPI() {
  return wrap(getTicketsMut());
}

export async function getTicketsAPI(filters = {}) {
  let rows = [...getTicketsMut()];
  if (filters.severity)
    rows = rows.filter((r) => r.severity === filters.severity);
  if (filters.status) rows = rows.filter((r) => r.status === filters.status);
  if (filters.tenantSearch && String(filters.tenantSearch).trim()) {
    const q = filters.tenantSearch.toLowerCase();
    rows = rows.filter(
      (r) =>
        r.tenantCode.toLowerCase().includes(q) ||
        r.companyName.toLowerCase().includes(q),
    );
  }
  if (filters.assignee)
    rows = rows.filter((r) => (r.assignee || "") === filters.assignee);
  return wrap(rows);
}

export async function createTicketAPI(body) {
  const id = `tkt-${Date.now()}`;
  getTicketsMut().unshift({
    id,
    ticketNumber: id,
    subject: body.subject || "New ticket",
    description: body.description || "",
    tenantId: body.tenantId || "tnt-1000",
    tenantCode: body.tenantCode || "MH-0001",
    companyName: body.companyName || "Unknown",
    severity: body.severity || "medium",
    priority: "P3",
    status: "open",
    assignee: null,
    slaDeadline: new Date(Date.now() + 86400000).toISOString(),
    createdAt: new Date().toISOString(),
    comments: [],
    linkedAlerts: [],
    linkedJobs: [],
  });
  return wrapMutate({ id });
}

export async function updateTicketAPI(id, body) {
  const t = getTicketsMut().find((x) => x.id === id);
  if (t) Object.assign(t, body);
  return wrapMutate({ id, ok: true });
}

export async function searchTenantsAPI(query) {
  const q = String(query || "")
    .toLowerCase()
    .trim();
  let list = [...platformTenants.tenantsList];
  if (q) {
    list = list.filter(
      (t) =>
        t.companyName.toLowerCase().includes(q) ||
        t.tenantCode.toLowerCase().includes(q) ||
        t.domain.toLowerCase().includes(q),
    );
  }
  return wrap({ items: list.slice(0, 15) });
}

export async function getTenantDiagnosticsAPI(tenantId) {
  return wrap(platformSupport.buildTenantDiagnostics(tenantId));
}

export async function getRunbooksListAPI() {
  return wrap(getRunbooksMut());
}

export async function getRunbooksAPI(filters = {}) {
  let rows = [...getRunbooksMut()];
  if (filters.category && filters.category !== "All") {
    rows = rows.filter((r) => r.category === filters.category);
  }
  if (filters.search && String(filters.search).trim()) {
    const q = String(filters.search).toLowerCase();
    rows = rows.filter((r) => r.title.toLowerCase().includes(q));
  }
  return wrap(rows);
}

export async function markRunbookUsefulAPI(id) {
  const r = getRunbooksMut().find((x) => x.id === id);
  if (r) r.usefulCount = (r.usefulCount || 0) + 1;
  return wrapMutate({ id, usefulCount: r?.usefulCount });
}

/* —— Platform: settings —— */
export async function getGeneralSettingsAPI() {
  return wrap(getGeneralSettingsMut());
}

export async function updateGeneralSettingsAPI(body) {
  Object.assign(getGeneralSettingsMut(), body);
  return wrapMutate({ ok: true });
}

export async function createMaintenanceWindowAPI(entry) {
  const list = getGeneralSettingsMut().maintenanceWindows || [];
  list.push({
    id: `mw-${Date.now()}`,
    ...entry,
    addedBy: entry.addedBy || "platform.admin@meetinghub.ai",
  });
  getGeneralSettingsMut().maintenanceWindows = list;
  return wrapMutate({ ok: true });
}

export async function deleteMaintenanceWindowAPI(id) {
  const g = getGeneralSettingsMut();
  g.maintenanceWindows = (g.maintenanceWindows || []).filter(
    (w) => w.id !== id,
  );
  return wrapMutate({ id, deleted: true });
}

export async function getFeatureFlagsAPI() {
  return wrap(getFeatureFlagsMut());
}

export async function toggleFeatureFlagAPI(id) {
  const f = getFeatureFlagsMut().find((x) => x.id === id);
  if (f) f.enabled = !f.enabled;
  return wrapMutate({ id, enabled: f?.enabled });
}

export async function updateFlagScopeAPI(id, scope) {
  const f = getFeatureFlagsMut().find((x) => x.id === id);
  if (f) {
    f.scope = { ...f.scope, ...scope };
    if (scope.allPlans) {
      f.scopeLabel = "All plans";
    } else {
      const parts = [];
      if (scope.starter) parts.push("Starter");
      if (scope.growth) parts.push("Growth");
      if (scope.enterprise) parts.push("Enterprise");
      const t = (scope.tenantIds || []).length;
      f.scopeLabel = parts.length
        ? `${parts.join(", ")}${t ? ` + ${t} tenant(s)` : ""}`
        : t
          ? `${t} tenant(s)`
          : "Custom";
    }
  }
  return wrapMutate({ id, scope });
}

export async function createFeatureFlagAPI(body) {
  const id = `ff-${Date.now()}`;
  getFeatureFlagsMut().unshift({
    id,
    key: body.key || `ff.new.${Date.now()}`,
    description: body.description || "New flag",
    environment: "staging",
    scopeLabel: "All plans",
    scope: {
      allPlans: true,
      starter: true,
      growth: true,
      enterprise: true,
      tenantIds: [],
    },
    enabled: false,
    dangerous: false,
    owner: body.owner || "platform@meetinghub.ai",
    rolloutPct: 0,
    updatedAt: new Date().toISOString(),
  });
  return wrapMutate({ id });
}

export async function getStorageRetentionMatrixAPI() {
  return wrap(getRetentionMatrixMut());
}

export async function getStorageRetentionAPI() {
  return wrap({
    matrix: JSON.parse(JSON.stringify(getRetentionMatrixMut())),
    minimums: { ...platformSettings.retentionMinimums },
  });
}

export async function updateRetentionAPI(rows) {
  retentionMatrixMutable = JSON.parse(JSON.stringify(rows));
  return wrapMutate({ ok: true });
}

export async function getStorageUsageAPI() {
  return wrap({
    byType: platformSettings.storageUsageByType,
    totals: platformSettings.storageUsageTotals,
  });
}

/* —— Mutable: company —— */
let companyActionCenterMutable = null;
function getCompanyActionCenterMut() {
  if (!companyActionCenterMutable) {
    companyActionCenterMutable = JSON.parse(
      JSON.stringify(companyDashboard.actionCenterItemsSeed),
    );
  }
  return companyActionCenterMutable;
}

let companyScheduleMutable = null;
function getCompanyScheduleMut() {
  if (!companyScheduleMutable) {
    companyScheduleMutable = JSON.parse(
      JSON.stringify(companyDashboard.scheduleMeetingsSeed),
    );
  }
  return companyScheduleMutable;
}

let companyUsersMutable = null;
function getCompanyUsersMut() {
  if (!companyUsersMutable) {
    companyUsersMutable = JSON.parse(JSON.stringify(companyUsers.usersList));
  }
  return companyUsersMutable;
}

let companyDepartmentsMutable = null;
function getCompanyDepartmentsMut() {
  if (!companyDepartmentsMutable) {
    companyDepartmentsMutable = JSON.parse(
      JSON.stringify(companyDepartments.departmentsList),
    );
  }
  return companyDepartmentsMutable;
}

const companyDepartmentDetailOverrides = {};
const companyUserDetailOverrides = {};

let companyOrgMappingsMutable = null;
function getCompanyOrgMappingsMut() {
  if (!companyOrgMappingsMutable) {
    companyOrgMappingsMutable = JSON.parse(
      JSON.stringify(companyDepartments.orgMappingsSeed),
    );
  }
  return companyOrgMappingsMutable;
}

let companyRoleRolesMutable = null;
let companyRolePermsMutable = null;
function getCompanyRoleRolesMut() {
  if (!companyRoleRolesMutable) {
    companyRoleRolesMutable = JSON.parse(
      JSON.stringify(companyUsers.roleMatrixRolesSeed),
    );
  }
  return companyRoleRolesMutable;
}
function getCompanyRolePermsMut() {
  if (!companyRolePermsMutable) {
    companyRolePermsMutable = JSON.parse(
      JSON.stringify(companyUsers.roleMatrixPermissionsSeed),
    );
  }
  return companyRolePermsMutable;
}

let companyIntegrationHubMutable = null;
function getCompanyIntegrationHubMut() {
  if (!companyIntegrationHubMutable) {
    companyIntegrationHubMutable = JSON.parse(
      JSON.stringify(companyIntegrations.integrationHubProviders),
    );
  }
  return companyIntegrationHubMutable;
}

let companyMicrosoftSetupMutable = null;
function getCompanyMicrosoftSetupMut() {
  if (!companyMicrosoftSetupMutable) {
    companyMicrosoftSetupMutable = JSON.parse(
      JSON.stringify(companyIntegrations.microsoftSetupState),
    );
  }
  return companyMicrosoftSetupMutable;
}

let companyGoogleSetupMutable = null;
function getCompanyGoogleSetupMut() {
  if (!companyGoogleSetupMutable) {
    companyGoogleSetupMutable = JSON.parse(
      JSON.stringify(companyIntegrations.googleSetupState),
    );
  }
  return companyGoogleSetupMutable;
}

let companyWhatsappSetupMutable = null;
function getCompanyWhatsappSetupMut() {
  if (!companyWhatsappSetupMutable) {
    companyWhatsappSetupMutable = JSON.parse(
      JSON.stringify(companyIntegrations.whatsappSetupState),
    );
  }
  return companyWhatsappSetupMutable;
}

let companyChannelsOverviewMutable = null;
function getCompanyChannelsOverviewMut() {
  if (!companyChannelsOverviewMutable) {
    companyChannelsOverviewMutable = JSON.parse(
      JSON.stringify(companyChannels.channelsOverviewExtended),
    );
  }
  return companyChannelsOverviewMutable;
}

let companyTeamsMenuMutable = null;
function getCompanyTeamsMenuMut() {
  if (!companyTeamsMenuMutable) {
    companyTeamsMenuMutable = JSON.parse(
      JSON.stringify(companyChannels.teamsMenuConfig),
    );
  }
  return companyTeamsMenuMutable;
}

let companyWhatsappMenuMutable = null;
function getCompanyWhatsappMenuMut() {
  if (!companyWhatsappMenuMutable) {
    companyWhatsappMenuMutable = JSON.parse(
      JSON.stringify(companyChannels.whatsappMenuConfig),
    );
  }
  return companyWhatsappMenuMutable;
}

let companySchedulingRulesMutable = null;
function getCompanySchedulingRulesMut() {
  if (!companySchedulingRulesMutable) {
    companySchedulingRulesMutable = JSON.parse(
      JSON.stringify(companyScheduling.schedulingRulesList),
    );
  }
  return companySchedulingRulesMutable;
}

let companyWorkingHoursMutable = null;
function getCompanyWorkingHoursMut() {
  if (!companyWorkingHoursMutable) {
    companyWorkingHoursMutable = JSON.parse(
      JSON.stringify(companyScheduling.workingHoursConfig),
    );
  }
  return companyWorkingHoursMutable;
}

let companyResourceRulesMutable = null;
function getCompanyResourceRulesMut() {
  if (!companyResourceRulesMutable) {
    companyResourceRulesMutable = JSON.parse(
      JSON.stringify(companyScheduling.resourceRulesList),
    );
  }
  return companyResourceRulesMutable;
}

let companyAliasMutable = null;
function getCompanyAliasMut() {
  if (!companyAliasMutable) {
    companyAliasMutable = JSON.parse(
      JSON.stringify(companyDirectory.aliasList),
    );
  }
  return companyAliasMutable;
}

let companyGroupMappingsMutable = null;
function getCompanyGroupMappingsMut() {
  if (!companyGroupMappingsMutable) {
    companyGroupMappingsMutable = JSON.parse(
      JSON.stringify(companyDirectory.groupMappings),
    );
  }
  return companyGroupMappingsMutable;
}

/* —— Company: dashboard —— */
export async function getTenantDashboardAPI() {
  return wrap({
    tenantDashboardKPIs: companyDashboard.tenantDashboardKPIs,
    actionCenterItems: companyDashboard.actionCenterItems,
    todaysSchedule: companyDashboard.todaysSchedule,
    companyTenantContext: companyDashboard.companyTenantContext,
    dashboardCharts: companyDashboard.dashboardCharts,
    needsAttentionItems: companyDashboard.needsAttentionItems,
    recentBookingsDashboard: companyDashboard.recentBookingsDashboard,
    remindersSummary: companyDashboard.remindersSummary,
  });
}

export async function getTenantDashboardKPIsAPI() {
  return wrap(companyDashboard.tenantDashboardKPIs);
}

export async function getDashboardKPIsAPI() {
  return wrap({
    kpis: companyDashboard.tenantDashboardKPIs,
    tenant: companyDashboard.companyTenantContext,
    needsAttention: companyDashboard.needsAttentionItems,
    recentBookings: companyDashboard.recentBookingsDashboard,
    reminders: companyDashboard.remindersSummary,
  });
}

export async function getDashboardChartsAPI() {
  return wrap(companyDashboard.dashboardCharts);
}

export async function getActionCenterItemsAPI() {
  const rows = getCompanyActionCenterMut().filter((x) => !x.resolved);
  return wrap(rows);
}

export async function resolveActionItemAPI(id, note) {
  const row = getCompanyActionCenterMut().find((x) => x.id === id);
  if (row) {
    row.resolved = true;
    row.resolvedNote = note || "";
    row.resolvedAt = new Date().toISOString();
  }
  return wrapMutate({ id, ok: true });
}

export async function dismissActionItemAPI(id) {
  const row = getCompanyActionCenterMut().find((x) => x.id === id);
  if (row) {
    row.resolved = true;
    row.dismissed = true;
  }
  return wrapMutate({ id, ok: true });
}

export async function getTodaysScheduleAPI(view = "day") {
  const meetings = getCompanyScheduleMut();
  const sidebar = companyDashboard.scheduleSidebar;
  return wrap({ view, meetings, sidebar });
}

export async function rescheduleMeetingAPI(id, body) {
  const m = getCompanyScheduleMut().find((x) => x.id === id);
  if (m && body?.startAt) {
    const start = new Date(body.startAt);
    const end = new Date(start.getTime() + 45 * 60000);
    m.startAt = start.toISOString();
    m.endAt = end.toISOString();
  }
  const mm = getCompanyMeetingsMut().find((x) => x.id === id);
  if (mm && body?.startAt) {
    mm.startAt = body.startAt;
    if (body.endAt) mm.endAt = body.endAt;
  }
  return wrapMutate({ id, ok: true });
}

export async function cancelMeetingAPI(id) {
  const m = getCompanyScheduleMut().find((x) => x.id === id);
  if (m) m.status = "cancelled";
  const mm = getCompanyMeetingsMut().find((x) => x.id === id);
  if (mm) mm.status = "cancelled";
  return wrapMutate({ id, ok: true });
}

/* —— Company: users —— */
export async function getUsersListAPI() {
  return wrap(getCompanyUsersMut());
}

export async function getUserDetailAPI(userId) {
  const row = getCompanyUsersMut().find((u) => u.id === userId);
  const uo = companyUserDetailOverrides[userId] || {};
  const base = row
    ? { ...companyUsers.userDetailTemplate, ...row, ...uo, id: userId }
    : {
        ...companyUsers.userDetailTemplate,
        id: userId,
        displayName: "Unknown User",
        email: "unknown@acme.example",
        ...uo,
      };
  const np = uo.notificationPrefs;
  const merged = np
    ? { ...base, notificationPrefs: { ...base.notificationPrefs, ...np } }
    : base;
  return wrap({
    ...merged,
    accessModuleMatrix: companyUsers.accessModuleMatrix,
    activity: companyUsers.userActivitySeed,
  });
}

export async function updateUserProfileAPI(userId, body) {
  companyUserDetailOverrides[userId] = {
    ...(companyUserDetailOverrides[userId] || {}),
    ...body,
  };
  const row = getCompanyUsersMut().find((u) => u.id === userId);
  if (row) {
    if (body.displayName != null) row.displayName = body.displayName;
    if (body.jobTitle != null) row.jobTitle = body.jobTitle;
  }
  return wrapMutate({ id: userId, ok: true });
}

export async function changeUserRoleAPI(userId, role) {
  const row = getCompanyUsersMut().find((u) => u.id === userId);
  if (row) {
    row.role = role;
    row.roleLabel = companyUsers.companyRoleKeys[role] || role;
  }
  return wrapMutate({ id: userId, role });
}

export async function updateNotificationPrefsAPI(userId, prefs) {
  companyUserDetailOverrides[userId] = {
    ...(companyUserDetailOverrides[userId] || {}),
    notificationPrefs: {
      ...(companyUserDetailOverrides[userId]?.notificationPrefs || {}),
      ...prefs,
    },
  };
  return wrapMutate({ id: userId, ok: true });
}

export async function inviteUserAPI(body) {
  const emails = String(body.email || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const created = [];
  emails.forEach((email, i) => {
    const id = `usr-inv-${Date.now()}-${i}`;
    getCompanyUsersMut().push({
      id,
      displayName: email.split("@")[0],
      email,
      role: body.role || "viewer",
      roleLabel:
        companyUsers.companyRoleKeys[body.role || "viewer"] || "Viewer",
      department: body.department || "Engineering",
      departmentId: "dept-1",
      employeeId: `INV-${Date.now()}`,
      status: "pending",
      channels: ["Teams"],
      lastLoginAt: null,
      mfaEnabled: false,
    });
    created.push(id);
  });
  return wrapMutate({ ids: created });
}

export async function bulkInviteAPI(body) {
  return inviteUserAPI(body);
}

export async function deactivateUserAPI(userId) {
  const row = getCompanyUsersMut().find((u) => u.id === userId);
  if (row) row.status = "suspended";
  return wrapMutate({ id: userId, ok: true });
}

export async function bulkDeactivateUserAPI(userIds) {
  (userIds || []).forEach((id) => {
    const row = getCompanyUsersMut().find((u) => u.id === id);
    if (row) row.status = "suspended";
  });
  return wrapMutate({ ok: true });
}

export async function bulkAssignRoleAPI(userIds, role) {
  (userIds || []).forEach((id) => {
    const row = getCompanyUsersMut().find((u) => u.id === id);
    if (row) {
      row.role = role;
      row.roleLabel = companyUsers.companyRoleKeys[role] || role;
    }
  });
  return wrapMutate({ ok: true });
}

export async function getRoleMatrixAPI() {
  return wrap({
    modules: companyUsers.roleMatrixModules,
    roles: getCompanyRoleRolesMut(),
    permissions: getCompanyRolePermsMut(),
  });
}

export async function createCustomRoleAPI(body) {
  const id = `role_custom_${Date.now()}`;
  const baseRole = body.baseRoleId || "viewer";
  getCompanyRoleRolesMut().push({
    id,
    label: body.name || "Custom Role",
    locked: false,
    description: body.description || "Custom role",
    userCount: 0,
    baseRoleId: baseRole,
  });
  companyUsers.roleMatrixModules.forEach((m) => {
    const srcKey = `${m.id}:${baseRole}`;
    const src = getCompanyRolePermsMut()[srcKey] || {
      view: true,
      create: false,
      edit: false,
      approve: false,
    };
    getCompanyRolePermsMut()[`${m.id}:${id}`] = { ...src };
  });
  return wrapMutate({ id });
}

export async function updateCustomRoleAPI(roleId, moduleId, permKey, value) {
  const role = getCompanyRoleRolesMut().find((r) => r.id === roleId);
  if (role?.locked) {
    return wrapMutate({ ok: false, error: "Role is locked" });
  }
  const key = `${moduleId}:${roleId}`;
  const perms = getCompanyRolePermsMut();
  if (!perms[key])
    perms[key] = { view: false, create: false, edit: false, approve: false };
  if (["view", "create", "edit", "approve"].includes(permKey)) {
    perms[key][permKey] = !!value;
  }
  return wrapMutate({ key, ok: true });
}

export async function createUserAPI(body) {
  return wrap({ id: `usr-new-${Date.now()}`, ...body });
}

export async function updateUserAPI(userId, body) {
  const row = getCompanyUsersMut().find((u) => u.id === userId);
  if (row) Object.assign(row, body);
  return wrap({ id: userId, ...body });
}

/* —— Company: departments —— */
export async function getDepartmentsListAPI() {
  return wrap(getCompanyDepartmentsMut());
}

export async function getDepartmentDetailAPI(deptId) {
  const row = getCompanyDepartmentsMut().find((d) => d.id === deptId);
  const ov = companyDepartmentDetailOverrides[deptId] || {};
  const tpl = companyDepartments.departmentDetailTemplate;
  const baseRow = row || companyDepartments.departmentsList[0];
  const base = {
    ...tpl,
    ...baseRow,
    ...ov,
    id: deptId,
    bookingDefaults: {
      ...tpl.bookingDefaults,
      ...(baseRow?.bookingDefaults || {}),
      ...(ov.bookingDefaults || {}),
    },
    reminderDefaults: {
      ...tpl.reminderDefaults,
      ...(baseRow?.reminderDefaults || {}),
      ...(ov.reminderDefaults || {}),
    },
    approvalPolicy: {
      ...tpl.approvalPolicy,
      ...(baseRow?.approvalPolicy || {}),
      ...(ov.approvalPolicy || {}),
    },
  };
  const members = getCompanyUsersMut().filter((u) =>
    base.memberUserIds?.includes(u.id),
  );
  return wrap({ ...base, members });
}

export async function updateDepartmentAPI(deptId, body) {
  const row = getCompanyDepartmentsMut().find((d) => d.id === deptId);
  const prev = companyDepartmentDetailOverrides[deptId] || {};
  const { applyMode, ...rest } = body;
  const next = {
    ...prev,
    ...rest,
    bookingDefaults: { ...prev.bookingDefaults, ...rest.bookingDefaults },
    reminderDefaults: { ...prev.reminderDefaults, ...rest.reminderDefaults },
    approvalPolicy: { ...prev.approvalPolicy, ...rest.approvalPolicy },
  };
  if (row) {
    if (body.name != null) row.name = body.name;
    if (body.headUserId !== undefined) row.headUserId = body.headUserId;
  }
  companyDepartmentDetailOverrides[deptId] = next;
  return wrapMutate({ id: deptId, ok: true, applyMode });
}

export async function assignUsersToDeptAPI(deptId, userIds) {
  const ov = companyDepartmentDetailOverrides[deptId] || {};
  const prev = ov.memberUserIds || [];
  companyDepartmentDetailOverrides[deptId] = {
    ...ov,
    memberUserIds: [...new Set([...prev, ...(userIds || [])])],
  };
  return wrapMutate({ id: deptId, ok: true });
}

export async function archiveDepartmentAPI(id) {
  const row = getCompanyDepartmentsMut().find((d) => d.id === id);
  if (row) {
    row.archived = true;
    row.status = "archived";
  }
  return wrapMutate({ id, ok: true });
}

export async function mergeDepartmentsAPI(sourceId, targetId) {
  const list = getCompanyDepartmentsMut();
  const idx = list.findIndex((d) => d.id === sourceId);
  if (idx >= 0) list.splice(idx, 1);
  return wrapMutate({ sourceId, targetId, ok: true });
}

export async function getOrgMappingsAPI() {
  return wrap(getCompanyOrgMappingsMut());
}

export async function autoSuggestMappingsAPI() {
  const rows = getCompanyOrgMappingsMut();
  const depts = getCompanyDepartmentsMut().filter((d) => !d.archived);
  rows.forEach((r, i) => {
    r.suggestedDepartment =
      depts[i % depts.length]?.name || r.suggestedDepartment;
    if (r.status === "unmapped") {
      r.finalDepartmentId = depts[(i + 1) % depts.length]?.id || null;
      r.finalDepartmentName = depts[(i + 1) % depts.length]?.name || null;
    }
  });
  return wrap(rows);
}

export async function saveOrgMappingsAPI(rows) {
  companyOrgMappingsMutable = JSON.parse(JSON.stringify(rows));
  return wrapMutate({ saved: rows.length, ok: true });
}

/* —— Company: integrations —— */
export async function getIntegrationHubAPI() {
  return wrap({
    providers: getCompanyIntegrationHubMut(),
    checklists: companyIntegrations.integrationSetupChecklists,
    legacy: companyIntegrations.integrationHub,
  });
}

export async function getCompanyIntegrationHubAPI() {
  const res = await getIntegrationHubAPI();
  return res;
}

export async function runProviderTestAPI(providerId) {
  const p = getCompanyIntegrationHubMut().find((x) => x.id === providerId);
  if (p) p.lastSuccessAt = new Date().toISOString();
  return wrapMutate({ providerId, ok: true });
}

export async function getMicrosoftSetupAPI() {
  return wrap(getCompanyMicrosoftSetupMut());
}

export async function getMicrosoftSetupStepsAPI() {
  return wrap(companyIntegrations.microsoftSetupSteps);
}

export async function saveMicrosoftCredentialsAPI(body) {
  const m = getCompanyMicrosoftSetupMut();
  m.credentials = { ...m.credentials, ...body, saved: true };
  return wrapMutate({ ok: true });
}

export async function grantConsentAPI() {
  const m = getCompanyMicrosoftSetupMut();
  m.consent.graphStatus = "granted";
  m.consent.scopes = (m.consent.scopes || []).map((s) => ({
    ...s,
    granted: true,
  }));
  m.consent.verifiedAt = new Date().toISOString();
  return wrapMutate({ ok: true });
}

export async function runMicrosoftBookingTestAPI() {
  const m = getCompanyMicrosoftSetupMut();
  m.testBooking = {
    lastRunAt: new Date().toISOString(),
    success: true,
    message: "Test meeting created in calendar (mock).",
  };
  return wrapMutate({ ...m.testBooking });
}

export async function runBookingTestAPI() {
  return runMicrosoftBookingTestAPI();
}

export async function markTeamsAppUploadedAPI() {
  getCompanyMicrosoftSetupMut().teamsApp.uploadStatus = "uploaded";
  return wrapMutate({ ok: true });
}

export async function runMicrosoftConnectivityTestAPI() {
  return wrapMutate({
    ok: true,
    steps: ["credentials", "consent", "teams", "booking"],
  });
}

export async function getGoogleSetupAPI() {
  return wrap(getCompanyGoogleSetupMut());
}

export async function getGoogleSetupStepsAPI() {
  return wrap(companyIntegrations.googleSetupSteps);
}

export async function connectGoogleOAuthAPI() {
  const g = getCompanyGoogleSetupMut();
  g.connected = true;
  g.accountEmail = "connected@acme.example";
  g.tokenExpiresAt = new Date(Date.now() + 86400000 * 30).toISOString();
  return wrapMutate({ ok: true });
}

export async function runCalendarTestAPI() {
  const g = getCompanyGoogleSetupMut();
  g.calendarTest = { lastAt: new Date().toISOString(), success: true };
  return wrapMutate({ ...g.calendarTest });
}

export async function syncGoogleUsersAPI(scope) {
  const g = getCompanyGoogleSetupMut();
  g.userSync = {
    lastAt: new Date().toISOString(),
    count: 140 + Math.floor(Math.random() * 20),
    scope: scope || g.userSync?.scope || "all_org",
  };
  return wrapMutate({ ...g.userSync });
}

export async function testMeetArtifactAPI() {
  const g = getCompanyGoogleSetupMut();
  g.meetArtifact = {
    lastSample: 'Transcript: "Action items assigned to sales…" (mock)',
    ok: true,
  };
  return wrapMutate({ ...g.meetArtifact });
}

export async function getWhatsappSetupAPI() {
  return wrap(getCompanyWhatsappSetupMut());
}

export async function getWhatsappSetupStatusAPI() {
  return wrap(companyIntegrations.whatsappSetupStatus);
}

export async function connectWhatsAppAPI() {
  return wrapMutate({ ok: true });
}

export async function verifyWebhookAPI() {
  const w = getCompanyWhatsappSetupMut();
  w.webhookVerified = true;
  w.blocks = w.blocks.map((b) =>
    b.id === "wh" ? { ...b, status: "ok", detail: "Verified" } : b,
  );
  return wrapMutate({ ok: true });
}

export async function createWhatsAppTemplateAPI(body) {
  getCompanyWhatsappSetupMut().templates.push({
    id: `t-${Date.now()}`,
    name: body?.name || "new_template",
    status: "PENDING",
  });
  return wrapMutate({ ok: true });
}

export async function sendTestMessageAPI(phone) {
  return wrapMutate({ ok: true, phone: phone || "+96890000000" });
}

/* —— Company: channels —— */
export async function getChannelsOverviewAPI() {
  return wrap(getCompanyChannelsOverviewMut());
}

export async function getChannelOverviewAPI() {
  return wrap(companyChannels.channelOverview);
}

export async function getTeamsMenuConfigAPI() {
  return wrap(getCompanyTeamsMenuMut());
}

export async function publishTeamsMenuAPI(body) {
  Object.assign(getCompanyTeamsMenuMut(), body || {});
  return wrapMutate({ ok: true });
}

export async function getWhatsAppMenuConfigAPI() {
  return wrap(getCompanyWhatsappMenuMut());
}

export async function getWhatsappMenuConfigAPI() {
  return getWhatsAppMenuConfigAPI();
}

export async function publishWhatsAppMenuAPI(body) {
  Object.assign(getCompanyWhatsappMenuMut(), body || {});
  return wrapMutate({ ok: true });
}

/* —— Company: scheduling —— */
export async function getSchedulingRulesAPI() {
  return wrap(getCompanySchedulingRulesMut());
}

export async function getSchedulingRulesListAPI() {
  return getSchedulingRulesAPI();
}

export async function updateRulePriorityAPI(id, priority) {
  const row = getCompanySchedulingRulesMut().find((r) => r.id === id);
  if (row) row.priority = +priority;
  return wrapMutate({ id, ok: true });
}

export async function disableRuleAPI(id) {
  const row = getCompanySchedulingRulesMut().find((r) => r.id === id);
  if (row) row.enabled = !row.enabled;
  return wrapMutate({ id, enabled: row?.enabled });
}

export async function createSchedulingRuleAPI(body) {
  const id = `sr-${Date.now()}`;
  getCompanySchedulingRulesMut().unshift({
    id,
    name: body?.name || "New rule",
    category: body?.category || "Working Hours",
    priority: body?.priority ?? 50,
    enabled: true,
    scope: body?.scope || "global",
    effectiveFrom: new Date().toISOString(),
    conflicting: false,
    conflictHint: null,
  });
  return wrapMutate({ id });
}

export async function getWorkingHoursAPI() {
  return wrap(getCompanyWorkingHoursMut());
}

export async function getWorkingHoursConfigAPI() {
  return getWorkingHoursAPI();
}

export async function updateWorkingHoursAPI(body) {
  const cur = getCompanyWorkingHoursMut();
  Object.assign(cur, body);
  return wrapMutate({ ok: true });
}

export async function addExceptionAPI(entry) {
  const w = getCompanyWorkingHoursMut();
  w.exceptions = w.exceptions || [];
  w.exceptions.push({ id: `ex-${Date.now()}`, ...entry });
  return wrapMutate({ ok: true });
}

export async function getResourceRulesAPI() {
  return wrap(getCompanyResourceRulesMut());
}

export async function getResourceRulesListAPI() {
  return getResourceRulesAPI();
}

export async function updateResourceRuleAPI(id, body) {
  const row = getCompanyResourceRulesMut().find((r) => r.id === id);
  if (row) Object.assign(row, body);
  return wrapMutate({ id, ok: true });
}

export async function addResourceAPI(body) {
  const id = `rr-${Date.now()}`;
  getCompanyResourceRulesMut().push({
    id,
    name: body?.name || "New resource",
    resourceType: body?.resourceType || "Room",
    capacity: body?.capacity ?? 10,
    maxBookingMinutes: body?.maxBookingMinutes ?? 60,
    approvalRequired: false,
    availabilitySource: "Manual",
    blackouts: [],
    status: "available",
    bufferMinutes: 0,
  });
  return wrapMutate({ id });
}

/* —— Company: directory —— */
function filterDirectoryByQuery(q) {
  const needle = String(q || "")
    .toLowerCase()
    .trim();
  const people = companyDirectory.directoryResults.items.filter(
    (x) =>
      !needle ||
      x.displayName.toLowerCase().includes(needle) ||
      x.email.toLowerCase().includes(needle),
  );
  const groups = companyDirectory.directoryGroupsSeed.filter(
    (x) => !needle || x.displayName.toLowerCase().includes(needle),
  );
  const externals = companyDirectory.directoryExternalsSeed.filter(
    (x) =>
      !needle ||
      x.email.toLowerCase().includes(needle) ||
      x.displayName.toLowerCase().includes(needle),
  );
  return { people, groups, externals, query: needle };
}

export async function searchDirectoryAPI(query) {
  return wrap(filterDirectoryByQuery(query));
}

export async function getDirectoryResultsAPI() {
  return wrap(companyDirectory.directoryResults);
}

export async function forceSyncDirectoryAPI() {
  return wrapMutate({ synced: 128, ok: true });
}

export async function forceSyncUserAPI(userId) {
  return wrapMutate({ id: userId, ok: true });
}

export async function getAliasesAPI() {
  return wrap(getCompanyAliasMut());
}

export async function getAliasListAPI() {
  return getAliasesAPI();
}

export async function approveAliasAPI(id) {
  const row = getCompanyAliasMut().find((x) => x.id === id);
  if (row) {
    row.status = "approved";
    row.resolvedUsers = null;
  }
  return wrapMutate({ id, ok: true });
}

export async function addAliasAPI(body) {
  getCompanyAliasMut().push({
    id: `alias-${Date.now()}`,
    alias: body.alias,
    resolvedUser: body.resolvedUser || "Unassigned",
    resolvedUserId: body.resolvedUserId || null,
    resolvedUsers: null,
    source: "Manual",
    confidence: 100,
    status: "pending",
  });
  return wrapMutate({ ok: true });
}

export async function deleteAliasAPI(id) {
  const list = getCompanyAliasMut();
  const idx = list.findIndex((x) => x.id === id);
  if (idx >= 0) list.splice(idx, 1);
  return wrapMutate({ id, ok: true });
}

export async function resolveAliasConflictAPI(id, resolvedUserId) {
  const row = getCompanyAliasMut().find((x) => x.id === id);
  if (row) {
    row.status = "approved";
    row.resolvedUserId = resolvedUserId;
    row.resolvedUsers = null;
    row.resolvedUser = `User ${resolvedUserId}`;
  }
  return wrapMutate({ id, ok: true });
}

export async function getGroupMappingsAPI() {
  return wrap(getCompanyGroupMappingsMut());
}

export async function updateGroupRulesAPI(id, body) {
  const row = getCompanyGroupMappingsMut().find((x) => x.id === id);
  if (row) Object.assign(row, body);
  return wrapMutate({ id, ok: true });
}

export async function previewGroupExpansionAPI(id) {
  const row = getCompanyGroupMappingsMut().find((x) => x.id === id);
  return wrap({ members: row?.members || [], count: row?.memberCount || 0 });
}

/* —— Mutable: company meetings —— */
let companyMeetingsMutable = null;
function getCompanyMeetingsMut() {
  if (!companyMeetingsMutable) {
    companyMeetingsMutable = JSON.parse(
      JSON.stringify(companyMeetings.meetingsListSeed),
    );
  }
  return companyMeetingsMutable;
}

/* —— Mutable: company transcripts —— */
let transcriptQueueMutable = null;
function getTranscriptQueueMut() {
  if (!transcriptQueueMutable) {
    transcriptQueueMutable = JSON.parse(
      JSON.stringify(companyTranscripts.transcriptQueueSeed),
    );
  }
  return transcriptQueueMutable;
}

const momEditorStore = {};
function getMomEditorMutable(meetingId) {
  const mid = meetingId || "mtg-3000";
  if (!momEditorStore[mid]) {
    const seed = JSON.parse(JSON.stringify(companyTranscripts.momEditorSeed));
    seed.meetingId = mid;
    momEditorStore[mid] = seed;
  }
  return momEditorStore[mid];
}

let actionItemsMutable = null;
function getActionItemsMut() {
  if (!actionItemsMutable) {
    actionItemsMutable = JSON.parse(
      JSON.stringify(companyTranscripts.actionItemsSeed),
    );
  }
  return actionItemsMutable;
}

let companyTemplatesMutable = null;
function getCompanyTemplatesMut() {
  if (!companyTemplatesMutable) {
    companyTemplatesMutable = JSON.parse(
      JSON.stringify(companyTemplates.companyTemplatesSeed),
    );
  }
  return companyTemplatesMutable;
}

const companyTemplateDetailOverrides = {};

let reminderRulesMutable = null;
function getReminderRulesMut() {
  if (!reminderRulesMutable) {
    reminderRulesMutable = JSON.parse(
      JSON.stringify(companyNotifications.reminderRulesSeed),
    );
  }
  return reminderRulesMutable;
}

let notificationLogsMutable = null;
function getNotificationLogsMut() {
  if (!notificationLogsMutable) {
    notificationLogsMutable = JSON.parse(
      JSON.stringify(companyNotifications.notificationLogsSeed),
    );
  }
  return notificationLogsMutable;
}

let escalationRulesMutable = null;
function getEscalationRulesMut() {
  if (!escalationRulesMutable) {
    escalationRulesMutable = JSON.parse(
      JSON.stringify(companyNotifications.escalationRulesSeed),
    );
  }
  return escalationRulesMutable;
}

let companyAuditLogsMutable = null;
function getCompanyAuditLogsMut() {
  if (!companyAuditLogsMutable) {
    companyAuditLogsMutable = JSON.parse(
      JSON.stringify(companyAudit.companyAuditLogsSeed),
    );
  }
  return companyAuditLogsMutable;
}

let userActivityMutable = null;
function getUserActivityMut() {
  if (!userActivityMutable) {
    userActivityMutable = JSON.parse(
      JSON.stringify(companyAudit.userActivitySeed),
    );
  }
  return userActivityMutable;
}

let exportHistoryMutable = null;
function getExportHistoryMut() {
  if (!exportHistoryMutable) {
    exportHistoryMutable = JSON.parse(
      JSON.stringify(companyAudit.exportHistorySeed),
    );
  }
  return exportHistoryMutable;
}

let companyProfileMutable = null;
function getCompanyProfileMut() {
  if (!companyProfileMutable) {
    companyProfileMutable = JSON.parse(
      JSON.stringify(companySettings.companyProfileSeed),
    );
  }
  return companyProfileMutable;
}

let brandingMutable = null;
function getBrandingMut() {
  if (!brandingMutable) {
    brandingMutable = JSON.parse(JSON.stringify(companySettings.brandingSeed));
  }
  return brandingMutable;
}

let policiesMutable = null;
function getPoliciesMut() {
  if (!policiesMutable) {
    policiesMutable = JSON.parse(
      JSON.stringify(companySettings.policiesRetentionSeed),
    );
  }
  return policiesMutable;
}

function filterMeetings(list, filters = {}) {
  let out = [...list];
  if (filters.statuses?.length) {
    out = out.filter((m) =>
      filters.statuses
        .map((s) => s.toLowerCase())
        .includes(String(m.status).toLowerCase()),
    );
  }
  if (filters.channel) {
    out = out.filter((m) => m.channel === filters.channel);
  }
  if (filters.provider) {
    out = out.filter((m) => m.provider === filters.provider);
  }
  if (filters.organizerQuery) {
    const q = filters.organizerQuery.toLowerCase();
    out = out.filter(
      (m) =>
        (m.organizerName && m.organizerName.toLowerCase().includes(q)) ||
        (m.organizerEmail && m.organizerEmail.toLowerCase().includes(q)),
    );
  }
  if (filters.dateFrom) {
    const t = Date.parse(filters.dateFrom);
    out = out.filter((m) => Date.parse(m.startAt) >= t);
  }
  if (filters.dateTo) {
    const t = Date.parse(filters.dateTo);
    out = out.filter((m) => Date.parse(m.startAt) <= t);
  }
  if (filters.quick === "today") {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    const e = new Date(d);
    e.setDate(e.getDate() + 1);
    out = out.filter((m) => {
      const x = Date.parse(m.startAt);
      return x >= d.getTime() && x < e.getTime();
    });
  }
  if (filters.quick === "failed") {
    out = out.filter((m) => m.status === "failed");
  }
  if (filters.quick === "pending_mom") {
    out = out.filter((m) => m.pendingMOM);
  }
  return out;
}

/** @returns {Promise<{data: { items, total, page, pageSize }}>} */
export async function getMeetingsListAPI(
  filters = {},
  page = 1,
  pageSize = 10,
) {
  const all = getCompanyMeetingsMut();
  const items = filterMeetings(all, filters);
  const p = Math.max(1, page);
  const ps = Math.max(1, pageSize);
  const start = (p - 1) * ps;
  const slice = items.slice(start, start + ps);
  return wrap({ items: slice, total: items.length, page: p, pageSize: ps });
}

export async function searchOrganizersAPI(q) {
  const needle = (q || "").toLowerCase();
  const users = companyMeetings.directoryUsersForMeetings.filter(
    (u) =>
      !needle ||
      u.name.toLowerCase().includes(needle) ||
      u.email.toLowerCase().includes(needle),
  );
  return wrap(users);
}

export async function getMeetingDetailAPI(meetingId) {
  const row = getCompanyMeetingsMut().find((m) => m.id === meetingId);
  if (!row) return wrap(null);
  const extras = companyMeetings.meetingDetailExtras(meetingId, row);
  return wrap({ ...row, ...extras });
}

export async function bulkCancelMeetingsAPI(ids) {
  const list = getCompanyMeetingsMut();
  ids.forEach((id) => {
    const m = list.find((x) => x.id === id);
    if (m) m.status = "cancelled";
  });
  return wrapMutate({ ok: true, count: ids.length });
}

export async function exportMeetingsAPI(filters) {
  const items = filterMeetings(getCompanyMeetingsMut(), filters);
  return wrapMutate({
    ok: true,
    format: "csv",
    rowCount: items.length,
    downloadUrl: "https://exports.example/meetings.csv",
  });
}

export async function sendMeetingReminderAPI(meetingId) {
  return wrapMutate({ ok: true, meetingId, sent: 4 });
}

export async function addAttendeeAPI(meetingId, attendee) {
  const row = getCompanyMeetingsMut().find((m) => m.id === meetingId);
  const detail = await getMeetingDetailAPI(meetingId);
  const d = detail.data;
  if (d?.attendees && attendee) {
    d.attendees.push({
      name: attendee.name || attendee.email,
      email: attendee.email,
      response: "No response",
      availability: "Available",
    });
    if (row) row.attendeeCount = d.attendees.length;
  }
  return wrapMutate({ ok: true });
}

export async function retryTranscriptAPI(meetingId) {
  const q = getTranscriptQueueMut().find((x) => x.meetingId === meetingId);
  if (q) {
    q.transcriptStatus = "processing";
    q.failureReason = null;
  }
  return wrapMutate({ ok: true, meetingId });
}

export async function searchAttendeesAPI(q) {
  const needle = (q || "").toLowerCase();
  const all = [
    ...companyMeetings.directoryUsersForMeetings.map((u) => ({
      id: u.id,
      name: u.name,
      email: u.email,
      conflict: false,
    })),
    {
      id: "x1",
      name: "External Guest",
      email: "guest@external.com",
      conflict: Math.random() < 0.3,
    },
  ];
  const hit = !needle
    ? all
    : all.filter(
        (a) =>
          a.name.toLowerCase().includes(needle) ||
          a.email.toLowerCase().includes(needle),
      );
  return wrap(hit.slice(0, 12));
}

export async function checkAvailabilityAPI(payload) {
  await sleep();
  return wrap({
    suggested: companyMeetings.availabilitySlotsSeed,
    alternatives: companyMeetings.alternativeSlotsSeed,
    payload,
  });
}

export async function createMeetingAPI(body) {
  const list = getCompanyMeetingsMut();
  const id = `mtg-${3100 + list.length}`;
  list.unshift({
    id,
    subject: body.subject || "New meeting",
    startAt: body.startAt || new Date().toISOString(),
    endAt: body.endAt || new Date(Date.now() + 3600000).toISOString(),
    durationMin: body.durationMin || 60,
    organizerId: body.organizerId,
    organizerName: body.organizerName || "Organizer",
    organizerEmail: body.organizerEmail || "org@acme.example",
    attendeeCount: (body.attendeeIds || []).length || 1,
    provider: body.provider || "Microsoft",
    channel: body.channel || "Teams",
    status: "scheduled",
    roomResource: body.roomResource || null,
    bookingMethod: "Manual",
    notes: body.notes || "",
    joinLink: `https://meet.example/${id}`,
    pendingMOM: false,
  });
  return wrapMutate({ ok: true, id });
}

/* Legacy aliases */
export async function getBookingDeskSlotsAPI() {
  return wrap(companyMeetings.availabilitySlotsSeed);
}

/* —— Company: transcripts —— */
function filterTranscriptQueue(list, filters = {}) {
  let out = [...list];
  if (filters.status && filters.status !== "all") {
    out = out.filter((r) => r.transcriptStatus === filters.status);
  }
  if (filters.provider) {
    out = out.filter((r) => r.provider === filters.provider);
  }
  if (filters.dateFrom) {
    const t = Date.parse(filters.dateFrom);
    out = out.filter((r) => Date.parse(r.meetingDate) >= t);
  }
  if (filters.dateTo) {
    const t = Date.parse(filters.dateTo);
    out = out.filter((r) => Date.parse(r.meetingDate) <= t);
  }
  return out;
}

export async function getTranscriptQueueAPI(filters = {}) {
  return wrap(filterTranscriptQueue(getTranscriptQueueMut(), filters));
}

export async function retryTranscriptPullAPI(queueId) {
  const row = getTranscriptQueueMut().find((x) => x.id === queueId);
  if (row) {
    row.transcriptStatus = "processing";
    row.failureReason = null;
  }
  return wrapMutate({ ok: true, id: queueId });
}

export async function generateMOMAPI(queueId) {
  const row = getTranscriptQueueMut().find((x) => x.id === queueId);
  if (row) row.momStatus = "draft";
  return wrapMutate({ ok: true, id: queueId });
}

export async function getMOMEditorDataAPI(meetingId) {
  return wrap(getMomEditorMutable(meetingId));
}

export async function saveMOMDraftAPI(meetingId, body) {
  const m = getMomEditorMutable(meetingId);
  Object.assign(m, body);
  return wrapMutate({ ok: true });
}

export async function approveMOMAPI(meetingId) {
  const m = getMomEditorMutable(meetingId);
  m.status = "approved";
  return wrapMutate({ ok: true });
}

export async function rejectMOMAPI(meetingId, reason) {
  const m = getMomEditorMutable(meetingId);
  m.status = "rejected";
  m.rejectReason = reason;
  return wrapMutate({ ok: true });
}

export async function getActionItemsAPI(filters = {}) {
  let rows = getActionItemsMut();
  if (filters.status && filters.status !== "all") {
    rows = rows.filter((r) => r.status === filters.status);
  }
  if (filters.ownerQuery) {
    const q = filters.ownerQuery.toLowerCase();
    rows = rows.filter((r) => r.ownerName.toLowerCase().includes(q));
  }
  if (filters.priority && filters.priority !== "all") {
    rows = rows.filter((r) => r.priority === filters.priority);
  }
  if (filters.dueFrom) {
    rows = rows.filter((r) => r.dueDate >= filters.dueFrom);
  }
  if (filters.dueTo) {
    rows = rows.filter((r) => r.dueDate <= filters.dueTo);
  }
  return wrap(rows);
}

export async function updateActionStatusAPI(id, status) {
  const row = getActionItemsMut().find((x) => x.id === id);
  if (row) {
    row.status = status;
    row.statusHistory = row.statusHistory || [];
    row.statusHistory.push({
      at: new Date().toISOString(),
      status,
      by: "user",
    });
  }
  return wrapMutate({ ok: true });
}

export async function reassignActionAPI(id, ownerId, ownerName) {
  const row = getActionItemsMut().find((x) => x.id === id);
  if (row) {
    row.ownerId = ownerId;
    row.ownerName = ownerName;
  }
  return wrapMutate({ ok: true });
}

export async function addActionNoteAPI(id, note) {
  const row = getActionItemsMut().find((x) => x.id === id);
  if (row) {
    row.notes = row.notes || [];
    row.notes.push({ at: new Date().toISOString(), text: note });
  }
  return wrapMutate({ ok: true });
}

export async function getMomEditorDataAPI(meetingId) {
  return getMOMEditorDataAPI(meetingId);
}

/* —— Company: templates —— */
export async function getCompanyTemplatesAPI(filters = {}) {
  let rows = getCompanyTemplatesMut();
  if (filters.channel && filters.channel !== "all") {
    rows = rows.filter((r) => r.channel === filters.channel);
  }
  if (filters.type && filters.type !== "all") {
    rows = rows.filter((r) => r.type === filters.type);
  }
  if (filters.status && filters.status !== "all") {
    rows = rows.filter((r) => r.status === filters.status);
  }
  return wrap(rows);
}

export async function getCompanyTemplatesListAPI(filters) {
  return getCompanyTemplatesAPI(filters);
}

export async function getCompanyTemplateDetailAPI(id) {
  const isNew = !id || id === "new";
  const row = !isNew ? getCompanyTemplatesMut().find((t) => t.id === id) : null;
  const base = companyTemplates.companyTemplateDetailSeed(id, isNew || !row);
  if (row) {
    base.name = row.name;
    base.status = row.status;
    base.hasOverride = row.hasOverride;
  }
  const ov = companyTemplateDetailOverrides[id];
  return wrap(ov ? { ...base, ...ov } : base);
}

export async function saveCompanyTemplateAPI(id, body) {
  if (!id || id === "new") {
    const list = getCompanyTemplatesMut();
    const nid = `ctpl-${list.length}`;
    list.unshift({
      id: nid,
      name: body.name || "Untitled",
      scope: body.scope || "Company",
      language: "en",
      basedOnGlobalId: body.basedOnGlobalId || null,
      basedOnGlobalName: body.basedOnGlobalName || "",
      version: "1.0",
      status: "draft",
      channel: body.channel || "teams",
      type: body.type || "Reminder",
      hasOverride: false,
    });
    companyTemplateDetailOverrides[nid] = {
      ...companyTemplates.companyTemplateDetailSeed(nid, true),
      ...body,
      id: nid,
    };
    return wrapMutate({ ok: true, id: nid });
  }
  companyTemplateDetailOverrides[id] = {
    ...(companyTemplateDetailOverrides[id] || {}),
    ...body,
    id,
  };
  const row = getCompanyTemplatesMut().find((t) => t.id === id);
  if (row && body.name) row.name = body.name;
  return wrapMutate({ ok: true, id });
}

export async function publishCompanyTemplateAPI(id) {
  const row = getCompanyTemplatesMut().find((t) => t.id === id);
  if (row) row.status = "active";
  return wrapMutate({ ok: true, id });
}

export async function archiveCompanyTemplateAPI(id) {
  const row = getCompanyTemplatesMut().find((t) => t.id === id);
  if (row) row.status = "archived";
  return wrapMutate({ ok: true, id });
}

/* —— Company: notifications —— */
export async function getReminderRulesAPI() {
  return wrap(getReminderRulesMut());
}

export async function createReminderRuleAPI(body) {
  const list = getReminderRulesMut();
  const id = `rr-${list.length}`;
  list.push({
    id,
    name: body.name || "New rule",
    appliesTo: body.appliesTo || "all",
    channels: body.channels || ["email"],
    timingMinutes: body.timingMinutes ?? 15,
    status: "enabled",
    priority: list.length + 1,
    meetingTypeFilter: body.meetingTypeFilter || "all",
    department: body.department || null,
    hasConflict: false,
    conflictHint: null,
  });
  return wrapMutate({ ok: true, id });
}

export async function updateReminderRuleAPI(id, body) {
  const row = getReminderRulesMut().find((x) => x.id === id);
  if (row) Object.assign(row, body);
  return wrapMutate({ ok: true, id });
}

export async function reorderReminderRulesAPI(orderedIds) {
  const list = getReminderRulesMut();
  const map = new Map(list.map((r) => [r.id, r]));
  orderedIds.forEach((rid, i) => {
    const r = map.get(rid);
    if (r) r.priority = i + 1;
  });
  return wrapMutate({ ok: true });
}

export async function getNotificationLogsAPI(filters = {}) {
  let rows = getNotificationLogsMut();
  if (filters.channel && filters.channel !== "all") {
    rows = rows.filter((r) => r.channel === filters.channel);
  }
  if (filters.status && filters.status !== "all") {
    rows = rows.filter((r) => r.status === filters.status);
  }
  if (filters.meetingQuery) {
    const q = filters.meetingQuery.toLowerCase();
    rows = rows.filter((r) => (r.meetingTitle || "").toLowerCase().includes(q));
  }
  if (filters.dateFrom) {
    const t = Date.parse(filters.dateFrom);
    rows = rows.filter((r) => Date.parse(r.sentAt) >= t);
  }
  if (filters.dateTo) {
    const t = Date.parse(filters.dateTo);
    rows = rows.filter((r) => Date.parse(r.sentAt) <= t);
  }
  return wrap(rows);
}

export async function retryNotificationAPI(id) {
  const row = getNotificationLogsMut().find((x) => x.id === id);
  if (row) row.status = "retrying";
  return wrapMutate({ ok: true, id });
}

export async function muteNotificationAPI(id) {
  return wrapMutate({ ok: true, id, muted: true });
}

export async function getEscalationRulesAPI() {
  return wrap(getEscalationRulesMut());
}

export async function createEscalationRuleAPI(body) {
  const list = getEscalationRulesMut();
  const id = `er-${list.length}`;
  list.push({
    id,
    trigger: body.trigger || "Email fails",
    conditionAttempts: body.conditionAttempts ?? 2,
    fallbackAction: body.fallbackAction || "Send Email",
    delayMinutes: body.delayMinutes ?? 15,
    status: "enabled",
  });
  return wrapMutate({ ok: true, id });
}

/* —— Company: reports —— */
export async function getReportsHubAPI() {
  return wrap(companyReports.reportsHubSeed);
}

export async function scheduleReportExportAPI(body) {
  return wrapMutate({ ok: true, scheduleId: `sch-${Date.now()}`, ...body });
}

export async function getUtilizationReportAPI(dateRange, groupBy) {
  await sleep();
  const key =
    groupBy === "organizer"
      ? "byOrganizer"
      : groupBy === "provider"
        ? "byProvider"
        : "byDepartment";
  return wrap({
    dateRange: dateRange || {},
    groupBy: key,
    rows: companyReports.utilizationReportSeed[key],
    donut: companyReports.utilizationReportSeed.donut,
  });
}

export async function getMeetingAnalyticsAPI(dateRange, filters = {}) {
  await sleep();
  const base = companyReports.meetingAnalyticsSeed;
  let events = [...base.events];
  if (filters.department && filters.department !== "all") {
    events = events.filter((e) => e.department === filters.department);
  }
  if (filters.channel && filters.channel !== "all") {
    events = events.filter((e) => e.channel === filters.channel);
  }
  if (filters.statusDrill) {
    events = events.filter((e) => e.status === filters.statusDrill);
  }
  return wrap({ ...base, events, dateRange: dateRange || {} });
}

export async function getUtilizationDataAPI() {
  return wrap(companyReports.utilizationReportSeed.byDepartment);
}

export async function getReportsHubCardsAPI() {
  const hub = await getReportsHubAPI();
  return wrap(hub.data.categories);
}

/* —— Company: audit —— */
function filterCompanyAudit(list, filters = {}) {
  let rows = [...list];
  if (filters.module && filters.module !== "all") {
    rows = rows.filter((r) => r.module === filters.module);
  }
  if (filters.action && filters.action !== "all") {
    rows = rows.filter((r) => r.action === filters.action);
  }
  if (filters.actor) {
    const q = filters.actor.toLowerCase();
    rows = rows.filter((r) => r.actorEmail.toLowerCase().includes(q));
  }
  if (filters.dateFrom) {
    const t = Date.parse(filters.dateFrom);
    rows = rows.filter((r) => Date.parse(r.ts) >= t);
  }
  if (filters.dateTo) {
    const t = Date.parse(filters.dateTo);
    rows = rows.filter((r) => Date.parse(r.ts) <= t);
  }
  return rows;
}

export async function getCompanyAuditLogsAPI(filters = {}) {
  return wrap(filterCompanyAudit(getCompanyAuditLogsMut(), filters));
}

export async function getUserActivityAPI(dateRange) {
  await sleep();
  return wrap({ dateRange: dateRange || {}, rows: getUserActivityMut() });
}

export async function getUserActivityRowsAPI() {
  return wrap(getUserActivityMut());
}

export async function getExportHistoryAPI() {
  return wrap(getExportHistoryMut());
}

export async function createExportAPI(body) {
  const list = getExportHistoryMut();
  const id = `exp-${9000 + list.length}`;
  list.unshift({
    id,
    name: body.name || "Export",
    requestedBy: "admin@acme.example",
    createdAt: new Date().toISOString(),
    format: body.format || "CSV",
    status: "processing",
    downloadUrl: null,
  });
  return wrapMutate({ ok: true, id });
}

export async function downloadExportAPI(id) {
  return wrapMutate({ ok: true, id, url: `https://exports.example/${id}.csv` });
}

/* —— Company: settings —— */
export async function getCompanyProfileAPI() {
  return wrap(getCompanyProfileMut());
}

export async function updateCompanyProfileAPI(body) {
  Object.assign(getCompanyProfileMut(), body);
  return wrapMutate({ ok: true });
}

export async function getBrandingAPI() {
  return wrap(getBrandingMut());
}

export async function getBrandingConfigAPI() {
  return getBrandingAPI();
}

export async function updateBrandingAPI(body) {
  Object.assign(getBrandingMut(), body);
  return wrapMutate({ ok: true });
}

export async function uploadLogoAPI(fileMeta) {
  return wrapMutate({
    ok: true,
    url: "https://cdn.example/branding/uploaded-logo.png",
    fileMeta,
  });
}

export async function getPoliciesRetentionAPI() {
  return wrap(getPoliciesMut());
}

export async function updatePoliciesRetentionAPI(body) {
  Object.assign(getPoliciesMut(), body);
  return wrapMutate({ ok: true });
}

export async function getTemplateEditorDataAPI(id) {
  return getCompanyTemplateDetailAPI(id || "ctpl-0");
}
